export default function ASPStatusBadge({ status, className = '' }) {
  const statusConfig = {
    draft: {
      color: 'bg-gray-100 text-gray-800',
      label: 'Draft',
      description: 'Agreement is being prepared'
    },
    sent_to_lawyer: {
      color: 'bg-purple-100 text-purple-800',
      label: 'With Lawyer',
      description: 'Shared with lawyer for review'
    },
    ready_to_sign: {
      color: 'bg-blue-100 text-blue-800',
      label: 'Ready to Sign',
      description: 'Waiting for purchaser signature'
    },
    signed_by_buyer: {
      color: 'bg-yellow-100 text-yellow-800',
      label: 'Purchaser Signed',
      description: 'Waiting for vendor signature'
    },
    signed_by_developer: {
      color: 'bg-green-100 text-green-800',
      label: 'Vendor Signed',
      description: 'Finalizing execution'
    },
    fully_executed: {
      color: 'bg-green-600 text-white',
      label: 'Fully Executed',
      description: 'Agreement is binding'
    },
    lapsed: {
      color: 'bg-red-100 text-red-800',
      label: 'Lapsed',
      description: 'Agreement has expired'
    },
    withdrawn: {
      color: 'bg-red-100 text-red-800',
      label: 'Withdrawn',
      description: 'Agreement was cancelled'
    }
  };

  const config = statusConfig[status] || statusConfig.draft;

  return (
    <div className={`inline-flex items-center group relative ${className}`}>
      <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
        {config.label}
      </span>

      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10">
        {config.description}
        <svg className="absolute top-full left-1/2 transform -translate-x-1/2 text-gray-900 h-2 w-4" viewBox="0 0 16 8">
          <path fill="currentColor" d="M0 0l8 8 8-8z"/>
        </svg>
      </div>
    </div>
  );
}
